import { Component, Inject, Input, NgModuleRef } from '@angular/core';
import { IModalsService, IMODALS_SERVICE } from '@platform500services/p500-ui-kit';
import { DrillDownModal } from '../../../../../modules/settings/preset-list/modals/drill-down/drill-down.modal';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'td[gtd-edit-row-btn]',
  template: `
    <button p500-ui-button-icon color="primary" transparent="true" (click)="openDrillDownModal()">
      <p500-ui-icon name="pencil-underline"></p500-ui-icon>
    </button>
  `,
})
export class ReportingPresetsDrilldownModalComponent {
  @Input() rowId: any;

  constructor(@Inject(IMODALS_SERVICE) public modalsService: IModalsService, private ngModuleRef: NgModuleRef<any>) {}

  openDrillDownModal(): void {
    this.modalsService.open(
      DrillDownModal,
      {
        id: this.rowId,
      },
      this.ngModuleRef
    );
  }
}
